import React, { PropTypes , useEffect, useState } from "react";
import moment from "moment"; 

export const defaultFormat = (date, format = 'MM/DD/YYYY') => {
  return moment(date).format(format);
}